import React, { useState, useEffect, useRef } from "react"
import withStyles from "react-jss"
import request from "request-promise"
import axios from "axios"
import {
  container,
  SMALL_MOBILE_BREAKPOINT,
  MOBILE_BREAKPOINT,
} from "../../data/globalStyles"
import colors from "../../data/colors"
import WaffleChartSVG from "./WaffleChartSVG"
import {
  RESULTS_FADEIN,
  RESULTS_FADEOUT,
  ANIMATION_DURATION,
  RESULTS_BREAKPOINT,
} from "../../data/globalStyles"
import useWindowSize from "../../hooks/useWindowSize"
import { calculatePercentAndColor, calculateFinalABV } from "../../utils/helper"
const host =
  window.location.hostname === "localhost"
    ? "http://localhost:5000"
    : "https://epi-calculator-prod.k8s.us-east-1--production.containers.aws.conde.io/"

const styles = {
  [`@keyframes ${RESULTS_FADEIN}`]: {
    from: {
      opacity: 0,
    },
    to: {
      opacity: 1,
    },
  },
  [`@keyframes ${RESULTS_FADEOUT}`]: {
    from: {
      opacity: 1,
    },
    to: {
      opacity: 0,
    },
  },
  pageContainer: {
    //position: "absolute",
    top: 0,
    left: 0,
    minHeight: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "4rem",
    flexDirection: "column",
    width: "100%",
    overflowX: "hidden",
    [`@media only screen and (max-width: ${MOBILE_BREAKPOINT}px)`]: {
      padding: 0,
    },

    animation: ({ show }) =>
      `${
        show ? `$${RESULTS_FADEIN}` : `$${RESULTS_FADEOUT}`
      } ${ANIMATION_DURATION} ease-in-out`,
  },
  innerContainer: {
    width: "100%",
    maxWidth: "1100px",
    minHeight: "80vh",
    display: "flex",
    flexDirection: "row",
    backgroundColor: colors.white,
    "@media only screen and (max-width: 920px)": {
      flexDirection: "column",
    },
  },
  leftContainer: {
    width: "45%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    textAlign: "center",
    backgroundColor: colors.resultBackground,
    "@media only screen and (max-width: 920px)": {
      width: "100%",
    },
  },
  content: {
    minHeight: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    margin: "3rem 0",
  },
  drink: {
    fontSize: "calc(24px + (30 - 24) * ((100vw - 300px) / (1600 - 300)))",
    fontWeight: 500,
    margin: 0,
    fontFamily: "Jost",
    color: "#000000",
    // lineHeight: 2.8,
  },
  editableDrinkName: {
    position: "relative",
    // textDecoration: `underline solid 3px ${colors.orangeHighlight}`,
    borderBottom: `3px solid ${colors.orangeHighlight}`,
    display: "inline-block",
    minWidth: "120px",
    padding: 0,
    marginBottom: "20px",
    userSelect: "all",
    "&:after": {
      content: "'name your drink!'",
      fontSize: "calc(12px + (14 - 12) * ((100vw - 300px) / (1600 - 300)))",
      textAlign: "center",
      color: colors.orangeHighlight,
      position: "absolute",
      top: "110%",
      left: 0,
      width: "100%",
      height: "100%",
      userSelect: "all",
    },
  },
  nameSuggestion: {
    position: "absolute",
    left: 0,
    fontSize: "calc(12px + (14 - 12) * ((100vw - 300px) / (1600 - 300)))",
  },
  abv: {
    fontSize: "calc(64px + (72 - 64) * ((100vw - 300px) / (1600 - 300)))",
    fontWeight: 700,
    fontFamily: "Jost",
    margin: "1em 0 1em 0",
    color: colors.orangeHighlight,
    [`@media only screen and (max-width: ${RESULTS_BREAKPOINT}px)`]: {
      margin: "2rem 0 0 0",
    },
  },
  buildAnother: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: `2px solid ${colors.orangeHighlight}`,
    padding: "0.7rem 1rem",
    fontSize: "calc(18px + (20 - 18) * ((100vw - 300px) / (1600 - 300)))",
    fontWeight: 500,
    textAlign: "center",
    cursor: "pointer",
    color: "#000000",
    "&:after": {
      content: "''",
      position: "absolute",
      bottom: 0,
      left: 0,
      width: "100%",
      height: "8px",
      backgroundColor: colors.orangeHighlight,
    },
    [`@media only screen and (max-width: ${SMALL_MOBILE_BREAKPOINT}px)`]: {
      padding: "0.5rem 1.2rem",
    },
  },
  listButton: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "20px",
    color: "#4E749F",
    marginTop: "2rem",
  },
  downIcon: {
    marginTop: "4px",
  },
  rightContainer: {
    position: "relative",
    width: "55%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: colors.resultBackground,
    padding: "0.8rem",
    [`@media only screen and (max-width: ${RESULTS_BREAKPOINT}px)`]: {
      width: "100%",
    },
  },
  rightContent: {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "0 0.6rem 0 0.3rem",
    backgroundColor: colors.white,
  },
  ingredientsContainer: {
    display: "flex",
    flexDirection: "column",
    margin: "3rem 1.5rem 3rem 0",
    textAlign: "right",
  },
  ingredient: {
    maxWidth: "20ch",
    margin: "0.6rem 0",
    fontSize: "calc(14px + (16 - 14) * ((100vw - 300px) / (1600 - 300)))",
    lineHeight: 1.4,
    padding: "0 0.4rem",
  },
  exploreCockTailBox: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    marginTop: "3rem",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "FuturaPT",
    fontSize: "24px",
    lineHeight: "1.2em",
    marginLeft: "1.5rem",
    [`@media only screen and (max-width: ${SMALL_MOBILE_BREAKPOINT}px)`]: {
      marginLeft: "2rem",
    },
  },
  similarCockTailContainer: {
    width: "100%",
    maxWidth: "1150px",
  },
  headingText: {
    fontWeight: "600",
    [`@media only screen and (max-width: ${SMALL_MOBILE_BREAKPOINT}px)`]: {
      marginLeft: "0.2rem",
    },
  },
  heading: {
    fontWeight: "600",
    cursor: "pointer",
    textDecoration: "underline",
    marginLeft: "5.5rem",
    [`@media only screen and (max-width: ${SMALL_MOBILE_BREAKPOINT}px)`]: {
      marginLeft: "0.2rem",
    },
  },
  similarRecipies: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    margin: "3rem auto",
    [`@media only screen and (max-width: ${SMALL_MOBILE_BREAKPOINT}px)`]: {
      margin: "0",
    },
  },
  recipie: {
    margin: "1rem 4rem 1rem 0",
    border: "1px solid #DCC19E",
    cursor: "pointer",
  },
  text: {
    textTransform: "uppercase",
    fontSize: "12px",
    letterSpacing: "0.1em",
    fontWeight: "700",
    color: "#FF0000",
    marginLeft: "1em",
  },
  head: {
    textTransform: "capitalize",
    width: "280px",
    fontSize: "16px",
    lineHeight: "18px",
    fontWeight: "500",
    color: "#000000",
    marginBottom: "2em",
  },
}

const ResultsPage = ({
  classes,
  ingredients,
  mixAndServe,
  clearCalculator,
  setShow,
  activeSection,
  onAnimationEnd,
}) => {
  const { width } = useWindowSize()
  const [resultData, setResultData] = useState({
    drink: "Your Drink",
    ingredients: [],
    abv: 0,
  })

  const [data, setData] = useState({})

  const resultRef = useRef(null)

  const cockTailIngredients =
    ingredients &&
    ingredients
      .map((row, i) => {
        if (row.category === "amaro, liqueur, aperitif") return undefined
        else if (row.category && row.category !== "amaro, liqueur, aperitif")
          return row.category.toLowerCase()
      })
      .filter(
        (row) => row !== undefined && row.toLowerCase() !== "nonalcoholic"
      )

  const strIngredients = cockTailIngredients
    ? cockTailIngredients.join(",")
    : ""

  const getData = async (value) => {
    const options = {
      method: "GET",
      url: `${host}/getCocktails`,
      params: { searcVal: encodeURIComponent(value) },
    }
    const body = axios.request(options)
    const result = body
    return result
  }

  useEffect(() => {
    getData(strIngredients.replace(/ /g, ""))
      .then((data) => {
        setData(data)
      })
      .catch((err) => {
        console.error("err", err)
      })
  }, [strIngredients])
  let evalData = eval(data)

  let newEvalData =
    evalData && evalData.data && evalData.data.length > 0
      ? evalData.data
          .filter(
            (row) =>
              row.hed.toLowerCase().includes("cocktail") ||
              row.dek.toLowerCase().includes("cocktail") ||
              row.url.toLowerCase().includes("cocktail")
          )
          .filter((row) => row.type === "recipe")
          .slice(0, 6)
      : null

  useEffect(() => {
    if (ingredients && ingredients.length && mixAndServe.mix) {
      ingredients.sort((a, b) => (a.abv > b.abv ? -1 : b.abv > a.abv ? 1 : 0))
      const keys = Object.keys(ingredients[0])
      let stop = false
      keys.forEach((key) => {
        if (!ingredients[0][key]) stop = true
      })
      if (stop) return
      const finalIngredients = calculatePercentAndColor(ingredients, colors)

      const abv = calculateFinalABV(finalIngredients, mixAndServe)

      const freehandColors = ["#b4b4b4", "#9e5a93", "#b2e4f4", "#fb9d9d"]

      const finalIngredientsWithColors = finalIngredients.map((d, i) => ({
        ...d,
        hex: !d.category ? freehandColors[i % 4] : d.hex,
      }))

      setResultData((d) => ({
        ...d,
        abv,
        ingredients: finalIngredientsWithColors,
      }))
    }
  }, [ingredients, mixAndServe])

  const handleClick = () => {
    clearCalculator()
    setShow({
      inputPage: true,
      result: false,
    })
  }

  const handleKeyDown = ({ code }) => {
    if (code === "Enter") {
      handleClick()
    }
  }

  const Restart = () => (
    <>
      <div
        className={classes.buildAnother}
        onClick={handleClick}
        onKeyDown={handleKeyDown}
        tabIndex="0">
        Build another
      </div>
      {/* <div className={classes.listButton}>
        Make one of our {resultData.drink}
        <img className={classes.downIcon} src={chevronDown} alt="Down arrow." />
      </div> */}
    </>
  )

  const maxLength = 20
  const onKeyDwn = (e) => {
    const currentTextLength = e.target.outerText.length
    if (currentTextLength === maxLength && e.keyCode != 8) {
      e.preventDefault()
    }
  }

  useEffect(() => {
    if (resultRef && resultRef.current) resultRef.current.scrollIntoView()
  }, [activeSection])

  return activeSection === "result" ? (
    <div
      className={classes.pageContainer}
      onAnimationEnd={onAnimationEnd}
      ref={resultRef}>
      <div className={classes.innerContainer}>
        <div className={classes.leftContainer}>
          <div className={classes.content}>
            <div className={classes.drink}>
              <span
                onKeyDown={onKeyDwn}
                className={classes.editableDrinkName}
                contentEditable="true"
                suppressContentEditableWarning="true">
                {resultData.drink}
              </span>
              <span style={{ marginTop: "10px" }}>'s ABV is</span>
            </div>
            <div id="abv" className={classes.abv}>
              {resultData.abv}%
            </div>
            {width > RESULTS_BREAKPOINT ? <Restart /> : null}
          </div>
        </div>
        <div className={classes.rightContainer}>
          <div className={classes.rightContent}>
            <div className={classes.ingredientsContainer}>
              {resultData.ingredients.map((row, i) => {
                return (
                  <div
                    key={i}
                    className={classes.ingredient}
                    style={{
                      // textDecorationColor: row.color,
                      textDecorationColor: row.hex,
                      borderRight: `7px solid ${row.hex}`,
                    }}>
                    {row.name}
                  </div>
                )
              })}
            </div>
            <WaffleChartSVG data={resultData.ingredients} />
          </div>
        </div>
        {width <= RESULTS_BREAKPOINT ? (
          <div className={classes.leftContainer}>
            <div className={classes.content}>
              <Restart />
            </div>
          </div>
        ) : null}
      </div>
      <div className={classes.exploreCockTailBox}>
        {evalData && evalData.data && evalData.data.length > 0 ? (
          <div className={classes.similarCockTailContainer}>
            <div className={classes.headingText}>
              {"Explore cocktails with similar ingredients"}
            </div>
            <div className={classes.similarRecipies}>
              {newEvalData.map((row, i) => {
                const photoId = row.photoData ? row.photoData.id : null
                const file = row.photoData ? row.photoData.filename : null

                return (
                  <div
                    className={classes.recipie}
                    onClick={() => {
                      window.open(`https://www.epicurious.com${row.url}`)
                    }}>
                    <img
                      key={i}
                      src={`https://assets.epicurious.com/photos/${photoId}/4:3/w_313%2Cc_limit/${file}`}
                    />
                    <div className={classes.text}>
                      {row.type}
                      <div className={classes.head}>{row.hed}</div>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        ) : null}
        <div
          className={classes.heading}
          onClick={() => {
            window.open(
              "https://www.epicurious.com/search/?type=cocktail&content=recipe&sort=newest"
            )
          }}>
          Find cocktail recipes on Epicurious
        </div>
      </div>
    </div>
  ) : null
}

export default withStyles(styles)(ResultsPage)
